import {getRequest} from './apiRequests';
import localStorageRepository from '@/domain/repository/LocalStorageRepository';
import {Stats} from '@/domain/entities/Stats';

const statsRepository = {
  getStats: (projectUuid: string): Promise<Stats> => {
    const {access} = localStorageRepository.getCredentials();
    return getRequest<Stats>({
      path: `projects/${projectUuid}/dashboard/`,
      headers: {
        'Authorization': `Bearer ${access}`
      }
    });
  }
};

export default statsRepository;